var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('van-loading',{attrs:{"size":"24px","type":"spinner","vertical":""}},[_vm._v("加载中")]),_vm._v(" "),_c('van-button',{attrs:{"type":"default","round":"","size":"mini"},on:{"click":_vm.reset}},[_vm._v("亲~请点击再次刷新")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-621f1834","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loding.vue
// module id = null
// module chunks = 